
import { useState, useEffect } from 'react';
import PartnerInquiryModal from './PartnerInquiryModal';

export default function Navbar() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.querySelector('.hero-section');
      if (heroSection) {
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        setIsVisible(heroBottom > 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  if (!isVisible) return null;

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-transparent">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 sm:gap-4">
              <img
                src="https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/10d9fc1b609b54364963a5ea239520dd.png"
                alt="Bucket List Series"
                className="h-10 sm:h-14 w-auto"
              />
              <span className="text-xs sm:text-sm font-light italic text-white">
                Where the Game Takes Us
              </span>
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex items-center gap-8">
              <a
                href="https://bucketlistgolf.org"
                className="text-sm font-medium transition-colors whitespace-nowrap cursor-pointer text-white hover:text-yellow-400"
              >
                Home
              </a>
              <button
                onClick={() => scrollToSection('mission')}
                className="text-sm font-medium transition-colors whitespace-nowrap cursor-pointer text-white hover:text-yellow-400"
              >
                Our Mission
              </button>
              <button
                onClick={() => scrollToSection('what-sets-us-apart')}
                className="text-sm font-medium transition-colors whitespace-nowrap cursor-pointer text-white hover:text-yellow-400"
              >
                What Sets Us Apart
              </button>
              <button
                onClick={() => setIsModalOpen(true)}
                className="px-6 py-2.5 rounded-full font-medium text-sm transition-all whitespace-nowrap cursor-pointer bg-yellow-400 text-black hover:bg-yellow-500"
              >
                Get In Touch
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 space-y-3">
              <a
                href="https://bucketlistgolf.org"
                className="block w-full text-left px-4 py-2 text-sm font-medium text-white hover:text-yellow-400 transition-colors cursor-pointer"
              >
                Home
              </a>
              <button
                onClick={() => scrollToSection('mission')}
                className="block w-full text-left px-4 py-2 text-sm font-medium text-white hover:text-yellow-400 transition-colors cursor-pointer"
              >
                Our Mission
              </button>
              <button
                onClick={() => scrollToSection('what-sets-us-apart')}
                className="block w-full text-left px-4 py-2 text-sm font-medium text-white hover:text-yellow-400 transition-colors cursor-pointer"
              >
                What Sets Us Apart
              </button>
              <button
                onClick={() => setIsModalOpen(true)}
                className="block w-full px-4 py-2.5 rounded-full font-medium text-sm bg-yellow-400 text-black hover:bg-yellow-500 transition-all cursor-pointer"
              >
                Get In Touch
              </button>
            </div>
          )}
        </div>
      </nav>

      <PartnerInquiryModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
